import { getListProjectPersonsQueryOptions } from '@amarantos/api-client'
import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/route-error-fallback'
import { ProjectPersonsPanel } from '@/features/projects/components/project-persons-panel'
import { listAllProjectAssetsParams } from '@/features/projects/utils/project-asset-list'
import { projectAssetDialogSearchSchema } from '@/features/projects/utils/search'

export const Route = createFileRoute('/_authenticated/projects/$projectId/persons')({
	validateSearch: projectAssetDialogSearchSchema,
	loader: ({ context: { queryClient }, params: { projectId } }) => {
		queryClient.ensureQueryData(getListProjectPersonsQueryOptions(projectId, listAllProjectAssetsParams))
	},
	errorComponent: ({ error, reset }) => (
		<RouteErrorFallback error={error} reset={reset} fallbackMessageKey='error.load_project_persons' />
	),
	component: ProjectPersonsRoute,
})

function ProjectPersonsRoute() {
	const { projectId } = Route.useParams()
	const search = Route.useSearch()
	const navigate = Route.useNavigate()

	// Dialog state lives in the URL, so the create/edit dialogs are deep-linkable.
	const closeDialog = () => {
		navigate({ search: (previous) => ({ ...previous, dialog: undefined, assetId: undefined }) })
	}

	return (
		<ProjectPersonsPanel
			projectId={projectId}
			dialog={search.dialog}
			selectedId={search.assetId}
			onCreate={() => navigate({ search: (previous) => ({ ...previous, dialog: 'create' as const }) })}
			onEdit={(projectPerson) =>
				navigate({ search: (previous) => ({ ...previous, assetId: projectPerson.id, dialog: 'edit' as const }) })
			}
			onClose={closeDialog}
		/>
	)
}
